import moment from 'moment-timezone';
import * as R from 'ramda';

export function dateFormatterUtc(val, dateFormat) {
    return val
        ? moment
              .utc(val)
              .tz(moment.tz.guess())
              .format(dateFormat)
        : '-';
}

export function dateFormatter(val, dateFormat) {
    return val
        ? moment(val)
              .tz(moment.tz.guess())
              .format(dateFormat)
        : '-';
}

export function parseDate(str) {
    return str ? moment(str.replace(/(T.*)/, '')).toDate() : null;
}

export function parseDateFromUnixTimestamp(str) {
    return str ? moment.unix(Number(str)).format('MMM D, YYYY') : null;
}

/**
 * @export
 * @param {number} unixDate
 * @return {*}
 */
export function unixToMonthDayYear(unixDate) {
    return moment(unixDate * 1000)
        .local()
        .format('MM/DD/YYYY');
}

/**
 * @export
 * @param {number} unixDate
 * @return {*}
 */
export function unixToMonthDay(unixDate) {
    return moment(unixDate * 1000)
        .local()
        .format('M/D');
}

/**
 * @export
 * @param {string} val
 * @return {*}  {string}
 */
export function prettyDate(val) {
    return dateFormatter(val, 'MM-DD-YYYY');
}

/**
 * @export
 * @param {string} val
 * @return {*}  {string}
 */
export function prettyDateNoYear(val) {
    return dateFormatter(val, 'MM/DD');
}

/**
 * @export
 * @param {string} val
 * @return {*}  {string}
 */
export function prettyDateNoYearMonthDayOrdinal(val) {
    return dateFormatter(val, 'MMMM Do');
}

/**
 * @export
 * @param {string} val
 * @return {*}  {string}
 */
export function prettyDateMonthDayOrdinal(val) {
    return dateFormatter(val, 'MMMM Do, YYYY');
}

/**
 * @export
 * @param {number} unixDate
 * @return {*}
 */
export function prettyDateNoYearUnix(unixDate) {
    return moment(unixDate * 1000)
        .local()
        .format('MMMM Do');
}

export function prettyDatetimeNoYear(val) {
    if (R.isNil(val)) {
        return '-';
    }

    const format = 'MM/DD';

    if (moment.isMoment(val)) {
        return val.local().format(format);
    }

    return moment(val)
        .local()
        .format(format);
}

/**
 * @export
 * @param {string} val
 * @return {*}  {string}
 */
export function prettyLocaleTime(val) {
    return dateFormatter(val, 'LT');
}

export function userTimezone() {
    return moment.tz.guess();
}



// WEBPACK FOOTER //
// ./common/date_helper.js